/**
 * The screen the person is on, as the Error Log records it (2026-10-02): the
 * path, and the `tab` when there is one - `/rota?tab=shifts`. Nothing else
 * from the query, which can carry what someone typed into a search box.
 *
 * Sent with every signed-in request as `X-Client-Screen`, so a crash the
 * server writes down says which screen asked; and read by the browser's own
 * reporter for the faults only it can see. One definition for both, so the two
 * halves of a fault's record cannot describe the same screen differently.
 */
export function currentScreen(): string | null {
  if (typeof window === 'undefined' || !window.location) return null;
  const { pathname, search } = window.location;
  const tab = new URLSearchParams(search).get('tab');
  return tab ? `${pathname}?tab=${tab}` : pathname;
}
